if (!customElements.get('rm-hero-banners')) {
  customElements.define('rm-hero-banners', class extends HTMLElement {
    connectedCallback() {
      this.classList.remove('is-ready');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const init = () => {
        if (this.slider || !window.Flickity) return;
        this.track = this.querySelector('.rm-hero-banners__track');
        this.slides = [...this.track.children];
        if (this.slides.length < 2) return;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.status = this.querySelector('[data-banner-status]');
        const defaultSpeed = Number(this.dataset.speed);
        const slideSpeed = index => Number(this.slides[index]?.dataset.speed) || defaultSpeed;
        this.slider = new Flickity(this.track, {
          cellSelector: '.rm-hero-banner',
          wrapAround: true,
          prevNextButtons: false,
          pageDots: false,
          adaptiveHeight: true,
          autoPlay: this.dataset.autoplay === 'true' && !this.motion.matches ? slideSpeed(0) : false,
          pauseAutoPlayOnHover: true
        });
        this.resizeObserver = new ResizeObserver(() => {
          this.slider.resize();
          this.classList.add('is-ready');
        });
        this.slides.forEach(slide => this.resizeObserver.observe(slide));
        // The theme's Flickity build skips resize while a slide is moving.
        this.slider.on('settle', () => this.slider.resize());
        this.slider.on('change', index => {
          if (this.dataset.autoplay !== 'true' || this.motion.matches) return;
          this.slider.stopPlayer();
          this.slider.options.autoPlay = slideSpeed(index);
          this.slider.playPlayer();
        });
        const update = () => {
          this.slides.forEach((slide, index) => {
            const selected = index === this.slider.selectedIndex;
            slide.inert = !selected;
            slide.setAttribute('aria-hidden', String(!selected));
          });
          this.status.textContent = `${this.slider.selectedIndex + 1} / ${this.slides.length}`;
        };
        this.slider.on('change', update);
        this.querySelector('[data-banner-prev]').addEventListener('click', () => {
          this.slider.previous(true, this.motion.matches);
        }, options);
        this.querySelector('[data-banner-next]').addEventListener('click', () => {
          this.slider.next(true, this.motion.matches);
        }, options);
        document.addEventListener('shopify:block:select', (event) => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index < 0) return;
          this.slider.select(index, false, true);
        }, options);
        this.querySelectorAll('[data-banner-prev], [data-banner-next]').forEach(button => {
          button.hidden = false;
        });
        update();
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init, { ...options, once: true });
      } else {
        init();
      }
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      this.slider?.destroy();
      this.slider = null;
      this.slides?.forEach(slide => {
        slide.inert = false;
        slide.removeAttribute('aria-hidden');
      });
    }
  });
}
